export const FRAME_SEARCH_PARAMS = ['c_v'];
